module.exports = __webpack_public_path__ + "public/hws/images/loginimg_intl_zh-cn.png";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/loginimg_intl_zh-cn.png
// module id = 99
// module chunks = 0